/**
 * AWS MediaConvert supported video formats
 * Reference: https://docs.aws.amazon.com/mediaconvert/latest/ug/reference-codecs-containers-input.html
 */

// MIME types and extensions for AWS MediaConvert supported video formats
export const AWS_MEDIACONVERT_VIDEO_FORMATS: { [key: string]: string[] } = {
  // 3G2, 3GP
  'video/3gpp': ['.3gp', '.3g2'],
  'video/3gpp2': ['.3g2'],
  // ASF, WMV
  'video/x-ms-wmv': ['.wmv', '.asf'],
  'video/x-ms-asf': ['.asf'],
  // AVI
  'video/x-msvideo': ['.avi'],
  'video/avi': ['.avi'],
  // F4V, FLV
  'video/x-flv': ['.flv', '.f4v'],
  'video/flv': ['.flv'],
  // Matroska
  'video/x-matroska': ['.mkv'],
  'video/matroska': ['.mkv'],
  // MOV (QuickTime)
  'video/quicktime': ['.mov', '.qt'],
  // MP4
  'video/mp4': ['.mp4', '.m4v', '.m4p'],
  // MPEG-1
  'video/mpeg': ['.mpg', '.mpeg', '.mpe', '.m2v', '.mpv'],
  // MPEG-TS
  'video/mp2t': ['.ts', '.m2ts', '.mts'],
  // MXF
  'application/mxf': ['.mxf'],
  // WebM
  'video/webm': ['.webm'],
};

// Flat array of all supported MIME types for dropzone accept prop
export const AWS_MEDIACONVERT_VIDEO_MIME_TYPES = Object.keys(
  AWS_MEDIACONVERT_VIDEO_FORMATS
);

// Flat array of all supported extensions
export const AWS_MEDIACONVERT_VIDEO_EXTENSIONS = Object.values(
  AWS_MEDIACONVERT_VIDEO_FORMATS
).flat();

// Helper to check if a file type is a supported video format
export const isSupportedVideoFormat = (mimeType: string): boolean => {
  return AWS_MEDIACONVERT_VIDEO_MIME_TYPES.includes(mimeType);
};

// Helper to check if a file extension is a supported video format
export const isSupportedVideoExtension = (extension: string): boolean => {
  const normalizedExt = extension.startsWith('.')
    ? extension.toLowerCase()
    : `.${extension.toLowerCase()}`;
  return AWS_MEDIACONVERT_VIDEO_EXTENSIONS.includes(normalizedExt);
};
